export default [
  {
    title: '文案ID',
    key: 'docId',
    width: 48
  },
  {
    title: '文案内容',
    key: 'docContent',
    width: 220
  },
  {
    title: '游戏',
    key: 'gameNames',
    width: 180,
    overflow: true
  },
  {
    title: '字符数',
    key: 'charNum',
    align: 'center',
    width: 50
  },
  // {
  //   title: '关联创意',
  //   key: 'creativeCount',
  //   align: 'center',
  //   width: 50
  // },
  {
    title: '创建人',
    key: 'opName'
  },
  {
    title: '更新人',
    key: 'upOpName',
    width: 64
  },
  {
    title: '更新时间',
    key: 'upTime'
  },
  {
    title: '操作',
    key: 'control',
    width: 140
  }
]
